module.exports=[
  "Club",
  "Festival",
  "Festival - Legacy",
  "Private/Corporate",
  "Stand-alone",
  "Tour",
  "University"
]
